<template>
  <input style="display: none" ref="inputRef" />
</template>

<script>
export default {
  methods: {
    chooseFile ({ type = 'file', accept = '*' } = {}) {
      const { inputRef } = this.$refs
      return new Promise((resolve) => {
        inputRef.setAttribute('type', type)
        inputRef.setAttribute('accept', accept)
        let changeEnd = false
        inputRef.onchange = function _ () {
          if (!changeEnd) {
            resolve({ files: [...this.files] })
          }
          this.value = ''
          changeEnd = true
        }
        inputRef.click()
      })
    }
  }
}
</script>
